import type React from 'react';

import { FormattedTag } from 'src/components/formatted-tag/formatted-tag';

interface SidebarTitleProps {
  id: string;
}

export const SidebarTitle: React.FC<SidebarTitleProps> = ({ id }) => (
  <div className="opacity-70 px-16 py-10 mt-8">
    <FormattedTag id={id} className="text-[12px]/[20px] uppercase opacity-65" />
  </div>
);
